(function (global, factory) {
  if ('function' == typeof define && define.amd) define(['exports', 'lodash.camelcase', 'string-similarity'], factory);else if ('undefined' != typeof exports) factory(exports, require('lodash.camelcase'), require('string-similarity'));else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.lodash, global.stringSimilarity), global.utils = mod.exports;
  }
})(this, function (exports, _lodash, _stringSimilarity) {
  'use strict';

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    }

    return Array.from(arr);
  }

  Object.defineProperty(exports, '__esModule', {
    value: !0
  });

  var _lodash2 = _interopRequireDefault(_lodash),
      _stringSimilarity2 = _interopRequireDefault(_stringSimilarity),
      _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
  };

  exports.default = {
    handleType: function handleType(value) {
      var type = value;
      return 'function' != typeof value && (type = value.constructor), type === String ? ['[value]'] : type === Array ? ['<list>'] : type === Number || type === parseInt ? ['<n>', parseInt] : [''];
    },
    readOption: function readOption(option) {
      var value = option.defaultValue,
          contents = {},
          _iteratorNormalCompletion = !0,
          _didIteratorError = !1,
          _iteratorError = void 0;

      try {
        for (var _step, _iterator = option.usage[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = !0) {
          var name = _step.value,
              fromArgs = this.raw[name];
          'undefined' != typeof fromArgs && (value = fromArgs);
        }
      } catch (err) {
        _didIteratorError = !0, _iteratorError = err;
      } finally {
        try {
          !_iteratorNormalCompletion && _iterator.return && _iterator.return();
        } finally {
          if (_didIteratorError) throw _iteratorError;
        }
      }

      var count = -1,
          _iteratorNormalCompletion2 = !0,
          _didIteratorError2 = !1,
          _iteratorError2 = void 0;

      try {
        for (var _step2, _name, _iterator2 = option.usage[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = !0) {
          _name = _step2.value, count += 1;
          var propVal = value;
          Array.isArray(option.defaultValue) && ('undefined' == typeof propVal ? 'undefined' : _typeof(propVal)) !== _typeof(option.defaultValue) && (0 == count && this.raw._.push(propVal), propVal = [propVal]), 'undefined' != typeof option.defaultValue && ('undefined' == typeof propVal ? 'undefined' : _typeof(propVal)) !== _typeof(option.defaultValue) && (0 == count && this.raw._.push(propVal), propVal = option.defaultValue);
          var condition = !0;
          option.init && (option.init === toString && (condition = propVal.constructor === Number), condition && (propVal = option.init(propVal))), 1 < _name.length && (_name = (0, _lodash2.default)(_name)), contents[_name] = propVal;
        }
      } catch (err) {
        _didIteratorError2 = !0, _iteratorError2 = err;
      } finally {
        try {
          !_iteratorNormalCompletion2 && _iterator2.return && _iterator2.return();
        } finally {
          if (_didIteratorError2) throw _iteratorError2;
        }
      }

      return contents;
    },
    getOptions: function getOptions(definedSubcommand) {
      var _this = this,
          options = {},
          args = {},
          _iteratorNormalCompletion3 = !0,
          _didIteratorError3 = !1,
          _iteratorError3 = void 0;

      try {
        for (var _step3, _option, _iterator3 = this.details.options[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = !0) {
          (_option = _step3.value, 'undefined' != typeof _option.defaultValue) && Object.assign(options, this.readOption(_option));
        }
      } catch (err) {
        _didIteratorError3 = !0, _iteratorError3 = err;
      } finally {
        try {
          !_iteratorNormalCompletion3 && _iterator3.return && _iterator3.return();
        } finally {
          if (_didIteratorError3) throw _iteratorError3;
        }
      }

      Object.assign(args, this.raw);

      var _ = [].concat(_toConsumableArray(args._));

      for (var option in delete args._, args) {
        if ({}.hasOwnProperty.call(args, option)) {
          var related = this.isDefined(option, 'options');

          if (related) {
            var details = this.readOption(related);
            Object.assign(options, details);
          }

          related || definedSubcommand || function () {
            var availableOptions = [];

            _this.details.options.forEach(function (opt) {
              availableOptions.push.apply(availableOptions, _toConsumableArray(opt.usage));
            });

            var suggestOption = _stringSimilarity2.default.findBestMatch(option, availableOptions);

            if (console.log('The option "' + option + '" is unknown.'), 0.5 <= suggestOption.bestMatch.rating) {
              console.log(' Did you mean the following one?\n');

              var suggestion = _this.details.options.filter(function (item) {
                var _iteratorNormalCompletion4 = !0,
                    _didIteratorError4 = !1,
                    _iteratorError4 = void 0;

                try {
                  for (var _step4, flag, _iterator4 = item.usage[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = !0) {
                    if (flag = _step4.value, flag === suggestOption.bestMatch.target) return !0;
                  }
                } catch (err) {
                  _didIteratorError4 = !0, _iteratorError4 = err;
                } finally {
                  try {
                    !_iteratorNormalCompletion4 && _iterator4.return && _iterator4.return();
                  } finally {
                    if (_didIteratorError4) throw _iteratorError4;
                  }
                }

                return !1;
              });

              console.log(_this.generateDetails(suggestion)[0].trim() + '\n');
            } else console.log(' Here\'s a list of all available options: \n'), _this.showHelp();
          }();
        }
      }

      return options._ = _, options;
    },
    generateExamples: function generateExamples() {
      var examples = this.details.examples,
          parts = [];

      for (var item in examples) {
        if ({}.hasOwnProperty.call(examples, item)) {
          var usage = this.printSubColor('$ ' + examples[item].usage),
              description = this.printMainColor('- ' + examples[item].description);
          parts.push('  ' + description + '\n\n    ' + usage + '\n\n');
        }
      }

      return parts;
    },
    generateDetails: function generateDetails(kind) {
      var items = 'string' == typeof kind ? [].concat(_toConsumableArray(this.details[kind])) : [].concat(_toConsumableArray(kind)),
          parts = [],
          isCmd = 'commands' === kind;

      for (var item in items.sort(function (a, b) {
        var first = isCmd ? a.usage : a.usage[1],
            second = isCmd ? b.usage : b.usage[1];

        switch (!0) {
          case first < second:
            return -1;

          case first > second:
            return 1;

          default:
            return 0;
        }
      }), items) {
        if ({}.hasOwnProperty.call(items, item)) {
          var usage = items[item].usage,
              initial = items[item].defaultValue;
          if (usage.constructor === Array) if (isCmd) usage = usage.join(', ');else {
            var isVersion = usage.indexOf('v');
            usage = '-' + usage[0] + ', --' + usage[1], initial || (initial = items[item].init), usage += initial && -1 === isVersion ? ' ' + this.handleType(initial)[0] : '';
          }
          items[item].usage = usage;
        }
      }

      var longest = items.slice().sort(function (a, b) {
        return b.usage.length - a.usage.length;
      })[0].usage.length,
          _iteratorNormalCompletion5 = !0,
          _didIteratorError5 = !1,
          _iteratorError5 = void 0;

      try {
        for (var _step5, _iterator5 = items[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = !0) {
          var _item = _step5.value,
              usage = _item.usage,
              description = _item.description,
              defaultValue = _item.defaultValue,
              difference = longest - usage.length;
          usage += ' '.repeat(difference), 'undefined' != typeof defaultValue && ('boolean' == typeof defaultValue ? description += ' (' + (defaultValue ? 'enabled' : 'disabled') + ' by default)' : description += ' (defaults to ' + JSON.stringify(defaultValue) + ')'), parts.push('  ' + this.printMainColor(usage) + '  ' + this.printSubColor(description));
        }
      } catch (err) {
        _didIteratorError5 = !0, _iteratorError5 = err;
      } finally {
        try {
          !_iteratorNormalCompletion5 && _iterator5.return && _iterator5.return();
        } finally {
          if (_didIteratorError5) throw _iteratorError5;
        }
      }

      return parts;
    },
    runCommand: function runCommand(details, options) {
      if ('help' !== details.usage || this.config.help || (details.init = !1), details.init) {
        var sub = [].concat(this.sub);
        return sub.shift(), details.init.bind(this)(details.usage, sub, options);
      }

      return '';
    },
    isDefined: function isDefined(name, list) {
      var children = this.details[list],
          _iteratorNormalCompletion6 = !0,
          _didIteratorError6 = !1,
          _iteratorError6 = void 0;

      try {
        for (var _step6, _iterator6 = children[Symbol.iterator](); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = !0) {
          var child = _step6.value,
              usage = child.usage,
              type = usage.constructor;
          if (type === Array && -1 < usage.indexOf(name)) return child;
          if (type === String && usage === name) return child;
        }
      } catch (err) {
        _didIteratorError6 = !0, _iteratorError6 = err;
      } finally {
        try {
          !_iteratorNormalCompletion6 && _iterator6.return && _iterator6.return();
        } finally {
          if (_didIteratorError6) throw _iteratorError6;
        }
      }

      return !1;
    }
  };
});